export default __webpack_public_path__ + "static/media/handView.a5ee8df2.svg";